import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginApiService {
  readonly url = 'login';
  readonly microsoftLoginUrl = 'login/microsoft';
  readonly refreshTokenUrl = 'security/authentication/token/refresh';
  readonly userInfo = 'security/authentication/token/userInfo';
  readonly logout = 'security/authentication/token/logout';
  readonly loginSecurity = 'configuration/loginSecurity';
  constructor(private http: HttpClient) {
  }

  public login(username, password): Promise<any> {
    let authorizationHash;
    try {
      authorizationHash = btoa(`${username}:${password}`);
    } catch (e) {
      return Promise.reject();
    }

    const credentials = {userName: username, password};
    const headers = new HttpHeaders({Authorization: `Basic ${authorizationHash}`});
    return this.http.post(this.url, credentials, {headers}).toPromise();
  }

  public getUserInfo(): Observable<any> {
    return this.http.get(this.userInfo);
  }

  public userLogout(): Observable<any> {
    return this.http.get(this.logout);
  }

  public loginWithMicrosoft(): Promise<any> {
    return this.http.post(this.microsoftLoginUrl, {}).toPromise();
  }

  public getTokenFromAzureAuthCode(azureAuthenticationRequest): Promise<any> {
    return this.http.post(this.microsoftLoginUrl + '/authentication/token', azureAuthenticationRequest).toPromise();
  }

  public refreshToken(): Promise<any> {
    return this.http.post(this.refreshTokenUrl, {}).toPromise();
  }

  public isAzureEnabled(): Promise<any> {
    return this.http.get(this.microsoftLoginUrl + '/enable').toPromise();
  }

  public getLoginSecurityParams(): Promise<any>{
    return this.http.get(this.loginSecurity).toPromise();
  }



}
